// Add AngularJS state for ReactRouter
if (!J.reactLayout) {
    J.ng.addState('reactRouter', {
        template: '<div id="app-react" style="width:100%"></div>',
        url: '/rr/*path',
        reloadOnSearch: false,
        controller: [
            '$scope',
            '$rootScope',
            function ($scope: any, $rootScope: any) {
                J.react.router.init('app-react');

                const stateChangeStart = $rootScope.$on('$stateChangeStart', function () {
                    const el = document.getElementById('app-react');
                    if (el) {
                        ReactDOM.unmountComponentAtNode(el);
                    }
                });
                $scope.$on('$destroy', function () {
                    stateChangeStart();
                });
            },
        ],
    });
}
